// https://coolors.co/palette/606c38-283618-fefae0-dda15e-bc6c25
const DARK_OLIVE_GREEN = '#606C38';
const KOMBU_GREEN = '#283618';
const CORNSILK = '#FEFAE0';
const EARTH_YELLOW = '#DDA15E';
const LIVER_DOGS = '#BC6C25';

const WHITE = '#FFFFFF';
const BLACK = '#000000';

// Pallete 2: https://coolors.co/386641-6a994e-a7c957-f2e8cf-bc4749
const HUNTER_GREEN = '#386641';
const MAY_GREEN = '#6A994E';
const ANDROID_GREEN = '#A7C957';
const EGGSHELL = '#F2E8CF';
const BITTERSWEET_SHIMMER = '#BC4749';


const CONSTS = {
    HEADER_HEIGHT: '85px',
    light: {
        PRIMARY_COLOR: 'gray.200',
        PRIMARY_COLOR_BORDER: 'gray.100',
        SECONDARY_COLOR: 'blue',
    },
    dark: {
        // PRIMARY_COLOR: 'gray.900',
        // PRIMARY_COLOR_BORDER: 'gray.600',
        SECONDARY_COLOR: 'blue',
    }
}

export const HEADER_HEIGHT = '85px';

export const LIGHT_PRIMARY_COLOR = EGGSHELL;
export const LIGHT_SECONDARY_COLOR = BITTERSWEET_SHIMMER;

// export const LINK_COLOR = EARTH_YELLOW;

export const DARK_PRIMARY_COLOR = KOMBU_GREEN;
export const DARK_SECONDARY_COLOR = CORNSILK;

// export const LINK_COLOR = EARTH_YELLOW;



export default CONSTS;